<template>

    <ui-view class="view-action-form" v-spinner="loading" :hide="loading">

        <ui-heading :title="pageTitle">
            <ui-button color="positive" :loading="submitting" @click="$refs.form.submit()">Opslaan</ui-button>
            <ui-button
                color="medium"
                type="bordered"
                :to="backRoute"
                slot="left">Annuleren</ui-button>
        </ui-heading>

        <ui-form-panel auto-validate ref="form" @submit="submit">

            <ui-form-date-input
                title="Datum"
                name="date"
                rules="required"
                v-model="pendingSample.date"/>

            <ui-form-input
                number
                title="Bustal"
                name="bustal"
                v-model="pendingSample.bustal"/>

            <ui-form-input
                number
                title="Stukstal"
                name="stukstal"
                v-model="pendingSample.stukstal"/>

            <ui-form-textarea
                title="Bijzonderheden"
                name="notes"
                v-model="pendingSample.notes"/>

        </ui-form-panel>

    </ui-view>

</template>

<script>

import Vue from 'vue';
import moment from 'moment';
import { clone, pick } from 'es-toolkit';
import Component from 'vue-class-component';

import createQuery from 'js-core/js/apollo/queries/createQuery';

import FindSampleQuery from 'gql/queries/SampleForm/FindSample.gql';

import SampleMutations from 'app/mutations/SampleMutations';

@Component({

    name: 'SampleForm',
    apollo: {
        sample: createQuery(FindSampleQuery, {

            skip() {
                return !this.sampleId;
            },

            variables() {

                return {
                    id: this.sampleId
                };
            },

            response(response) {

                this.pendingSample = pick(response, Object.keys(this.pendingSample));
                this.pendingSample.date = moment(this.pendingSample.date).format('YYYY-MM-DD');
            }
        })
    }
})
export default class SampleForm extends Vue
{
    loading = 0;
    submitting = false;

    pendingSample = {
        date: null,
        bustal: null,
        stukstal: null,
        notes: null
    };

    breadcrumb(){

        return [{
            title: 'Vak detail',
            route: this.backRoute
        }, this.pageTitle];
    }

    async submit() {

        this.submitting = true;
        let input = clone(this.pendingSample);

        try {

            input.id = this.sampleId;

            await SampleMutations.update(input);

            this.logger.info('Sample updated');
            this.$toast.success('De monstering is aangepast');

            this.$router.replace(this.backRoute);
        }
        catch(e) {

            this.logger.error('Error updating sample', e);
            this.$toast.error('De monstering kon niet worden opgeslagen');
        }

        this.submitting = false;
    }

    get pageTitle(){

        return 'Monstering wijzigen';
    }

    get sampleId(){

        return this.$route.params.id;
    }

    get backRoute(){

        if(!this.sample){
            return { name: 'sections'};
        }

        return {
            name: 'section-detail',
            params: {
                id: this.sample.cohort.sectionId
            }
        };
    }
}

</script>